
export default {

    getVisibleSymbolMoney(){
        let _val= window.localStorage.getItem(localStorageKeys.visibleSymbolMoney);
		if(_val==null)
			return true;
		return (_val.toLowerCase() == 'true');
	},
     
    setVisibleSymbolMoney(val){
		window.localStorage.setItem(localStorageKeys.visibleSymbolMoney,val);
	},

    getAskBeforeBondCreation(){
		let _val= window.localStorage.getItem(localStorageKeys.askBeforeBondCreation);
		if(_val==null)
			return true;
		return (_val.toLowerCase() == 'true');
    },
       
	setAskBeforeBondCreation(val){
		window.localStorage.setItem(localStorageKeys.askBeforeBondCreation,val);
	},

	getLocalFinancialFileId(){
		let sessionValue = window.sessionStorage.getItem(localStorageKeys.localFinancialFileId);
		let localValue = window.localStorage.getItem(localStorageKeys.lastUsedFinancialFileId);
		if(sessionValue == "null" || sessionValue == null) {
			if(localValue) {
				this.setLocalFinancialFileId(localValue)
			} else {
				return null;
			}
		}
		return Number(sessionValue || localValue);
    },
       
	setLocalFinancialFileId(val){
		window.sessionStorage.setItem(localStorageKeys.localFinancialFileId,val);
	},
	setLastUsedFinancialFileId(val) {
		window.localStorage.setItem(localStorageKeys.lastUsedFinancialFileId, val);
	},
	getLocalUser(){
		let _val = window.localStorage.getItem(localStorageKeys.localUser);
		if(_val == "null" || _val == null)
			return null;
		return JSON.parse(_val);
    }, 
	setLocalUser(val){
		window.localStorage.setItem(localStorageKeys.localUser,val);
	},
	setTimezoneAlertStatus(val) {
		window.localStorage.setItem(localStorageKeys.timezoneAlert, val)
	},
	getTimezoneAlertStatus() {
		return window.localStorage.getItem(localStorageKeys.timezoneAlert)
	}
}


const localStorageKeys={
   visibleSymbolMoney:"visibleSymbolMoney",
   askBeforeBondCreation : "askBeforeBondCreation",
   localFinancialFileId : "localFinancialFileId",
   localUser: "localUser",
   timezoneAlert: 'timezoneAlert',
   lastUsedFinancialFileId: 'lastUsedFinancialFileId'
}